import { SVGAttributes } from 'react'

export function CheckIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.8979 3.77299L4.89795 9.77299C4.84569 9.82543 4.78359 9.86704 4.71522 9.89543C4.64685 9.92382 4.57354 9.93843 4.49951 9.93843C4.42548 9.93843 4.35217 9.92382 4.2838 9.89543C4.21543 9.86704 4.15333 9.82543 4.10107 9.77299L1.47607 7.14799C1.42375 7.09566 1.38224 7.03355 1.35393 6.96518C1.32561 6.89682 1.31104 6.82355 1.31104 6.74955C1.31104 6.67555 1.32561 6.60228 1.35393 6.53392C1.38224 6.46555 1.42375 6.40344 1.47607 6.35111C1.5284 6.29879 1.59051 6.25728 1.65888 6.22897C1.72724 6.20065 1.80051 6.18607 1.87451 6.18607C1.94851 6.18607 2.02178 6.20065 2.09014 6.22897C2.15851 6.25728 2.22062 6.29879 2.27295 6.35111L4.49998 8.57814L10.102 2.97705C10.2077 2.87138 10.351 2.81201 10.5004 2.81201C10.6499 2.81201 10.7932 2.87138 10.8989 2.97705C11.0046 3.08272 11.0639 3.22604 11.0639 3.37549C11.0639 3.52493 11.0046 3.66825 10.8989 3.77393L10.8979 3.77299Z'
        fill='currentColor'
      />
    </svg>
  )
}
